import React from "react";

import { useNavigate } from "react-router-dom";

import { makeUrl } from "commons/utils/http";

import { useSaveContext } from "context/save";

import useSnackbar from "./useSnackbar";

function useSaveUpdateWithSnackbar({
    successMsg,
    errorMsg,
    navigateTo,
}: {
    successMsg: string;
    errorMsg: string;
    navigateTo?: { link: string; id?: string };
}) {
    const navigate = useNavigate();

    const { onButtonSaveClick } = useSaveContext();

    const { enqueueSuccessSnackbar, enqueueFormErrorSnackbar, enqueueErrorSnackbar } =
        useSnackbar();

    const onButtonClick = React.useCallback(() => {
        onButtonSaveClick()
            .then((res) => {
                enqueueSuccessSnackbar(successMsg);

                if (navigateTo) {
                    const { link, id } = navigateTo;

                    if (id) {
                        const arr = res[0] as [{ id: string }];
                        const responseId = arr[0].id;

                        navigate(makeUrl(link, { [id]: responseId }));
                    } else {
                        navigate(link);
                    }
                }
            })
            .catch((error) => {
                if (error === "INVALID_FORM") {
                    enqueueFormErrorSnackbar();
                } else {
                    enqueueErrorSnackbar(errorMsg);
                }
            });
    }, [
        navigate,
        onButtonSaveClick,
        enqueueErrorSnackbar,
        enqueueSuccessSnackbar,
        enqueueFormErrorSnackbar,
        errorMsg,
        navigateTo,
        successMsg,
    ]);

    return React.useMemo(() => ({ onButtonClick }), [onButtonClick]);
}

export default useSaveUpdateWithSnackbar;
